/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccessTokenDtoFromJSON, AccessTokenDtoToJSON, } from './AccessTokenDto';
/**
 * Check if a given object implements the MyPlaylistInfoIdRequestDto interface.
 */
export function instanceOfMyPlaylistInfoIdRequestDto(value) {
    if ((!('playlistId' in value) && !('playlist_id' in value)) || (value['playlistId'] === undefined && value['playlist_id'] === undefined))
        return false;
    return true;
}
export function MyPlaylistInfoIdRequestDtoFromJSON(json) {
    return MyPlaylistInfoIdRequestDtoFromJSONTyped(json, false);
}
export function MyPlaylistInfoIdRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'playlistId': json['playlist_id'],
        'token': json['token'] == null ? undefined : AccessTokenDtoFromJSON(json['token']),
    };
}
export function MyPlaylistInfoIdRequestDtoToJSON(json) {
    return MyPlaylistInfoIdRequestDtoToJSONTyped(json, false);
}
export function MyPlaylistInfoIdRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'playlist_id': value['playlistId'],
        'token': AccessTokenDtoToJSON(value['token']),
    };
}
